export class Fields {
  public id: string;
  public fieldID: number;
  public fieldName: string;
  public categoryID: number;
  public enableFilter: boolean;
  public value: string;
}
export class FieldListModel {
  public name: string;
}






// WEBPACK FOOTER //
// ./src/app/models/Fields/field-model.ts